<template>
  <div>
    <FormComponent
      @searchForm="onHandleSearch"
      :searchFormItem="searchItem"
      :labelWidth="120"
      ref="FormComponent"
      @handleReset="handleReset"
      :hideKeys="['beQuit', 'year']"
    >
    <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
      <FormItem :label="$t('StrategicPosition')"
        ><!-- 战略性岗位 -->
        <Select v-model="searchItem.key_position" clearable>
          <Option v-for="item in YesOrNoList" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('keyPosition')"
        ><!-- 是否关键岗位 -->
        <Select v-model="searchItem.crux_position" clearable>
          <Option v-for="item in YesOrNoList" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </FormItem>
    </Col>
    <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
      <FormItem :label="$t('TalentPoolTag')"
        ><!-- 是否关键岗位 -->
        <Select v-model="searchItem.talent_pool_list" clearable multiple>
          <Option v-for="item in TalentPoolList" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </FormItem>
    </Col>
    </FormComponent>
    <Table
      style="margin-top: 20px"
      border
      :columns="tableColumns"
      :data="tableData"
    >
      <template slot-scope="{ row, index }" slot="talentPool ">
        <div v-if="row.talentPool">
          <Tag
            color="success"
            v-for="(tagItem, tagIndex) in row.talentPool.split(',')"
            :key="tagIndex"
            >{{ tagItem }}</Tag
          >
        </div>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="warning"
          icon="md-create"
          size="small"
          style="margin-right: 8px"
          @click="onEditItem(row, index)"
          >{{ $t("Edit") }}</Button
        ><!--编辑-->
      </template>
    </Table>
    <Row justify="space-between" style="margin: 20px 0">
      <Page :total="pageInfo.total" @on-change="pageChange" />
      <div style="display: flex; justify-content: flex-end; margin-top: 10px">
        <Button @click="handelFile">{{$t("import")}}</Button>
        <input
          type="file"
          ref="uploadExcel"
          accept=".xlsx,.xls"
          id="excel-file"
          @change="importExcel"
          v-show="false"
        />
        <Button @click="exportData" style="margin-left: 10px" type="primary">{{
          $t("Export_Formwork")
        }}</Button>
        <Button @click="exportDataEmp" style="margin-left: 10px" type="primary">{{
          $t("PB_Export")
        }}</Button>
      </div>
    </Row>
    <Modal
      v-model="isShowModal"
      title="能力评估"
      width="900px"
      @on-ok="onModalConfirm()"
      @on-cancel="isShowModal = false"
    >
      <Form :label-width="100" label-position="left" inline>
        <FormItem :label="$t('StrategicPosition')">
          <Checkbox
            true-value="1"
            false-value="0"
            v-model="editItem.keyPosition"
          />
        </FormItem>
        <FormItem :label="$t('keyPosition')">
          <Checkbox
            true-value="1"
            false-value="0"
            v-model="editItem.cruxPosition"
          />
        </FormItem>
      </Form>
      <Divider orientation="left">人才池</Divider>
      <Transfer
        :data="TalentPoolList"
        :target-keys="targetKeys"
        :render-format="renderTransfer"
        @on-change="handleTransferChange"
        :list-style="listStyle"
      ></Transfer>
    </Modal>
    <Modal v-model="isShowImportModal" title="数据导入" width="70%">
      <Table
        style="margin-top: 20px"
        border
        :columns="importRefColumns"
        :data="importData"
      >
        <template slot-scope="{ row, index }" slot="talentPool ">
          <div v-if="row.talentPool">
            <Tag
              color="success"
              v-for="(tagItem, tagIndex) in row.talentPool.split(',')"
              :key="tagIndex"
              >{{ tagItem }}</Tag
            >
          </div>
        </template>
      </Table>
      <div slot="footer">
        <Button @click="importEmpKeyPosition()" style="margin-right: 15px"
          >{{$t("Confirm")}}</Button
        >
        <Button @click="isShowImportModal = false">{{$t("Cancel")}}</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <Table :columns="importRefColumns" ref="inportTableRef" v-show="false" />
  </div>
</template>

<script>
import FormComponent from "./components/FormComponent.vue";
export default {
  components: {
    FormComponent,
  },
  data() {
    return {
      searchItem: {},
      isShowModal: false,
      List: [],
      tableData: [],
      pageInfo: {
        total: 0,
        pageNo: 1,
        pageSize: 10,
      },
      targetKeys: [],
      editItem: {},
      editIndex: 0,
      spinShow: false,
      importData: [],
      TalentPoolList: [],
      businessUnitList: [],
      departmentList: [],
      functionList: [],
      YesOrNoList:[],
      isShowImportModal: false,
      importRefColumns: [],
      listStyle: {
        width: "400px",
        height: "300px",
      },
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    tableColumns() {
      return [
        {
          title: this.$t('Employee_Code'), //"员工号"
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('Name'),  //"姓名"
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('English_Name'), //"英文名"
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('BU'), //"业务单元"
          key: "businessUnit",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnitList
                .filter((item) => item.code == params.row.businessUnit)
                .map((res) => res.ch_value)
            );
          },
        },
        {
          title: this.$t('Department'), //"大区"
          key: "department",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.departmentList
                .filter((item) => item.code == params.row.department)
                .map((res) => res.ch_value)
            );
          },
        },
        {
          title: this.$t('Funciton'), //"职能"
          key: "postFun",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.functionList
                .filter((item) => item.code == params.row.postFun)
                .map((res) => res.ch_value)
            );
          },
        },
        {
          title: this.$t('positionCode'), //"职位Code"
          key: "positionCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('Position'), //"职位名称"
          key: "positionName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('StrategicPosition'), //"战略性岗位"
          key: "keyPosition",
          align: "center",
          minWidth: 120,
          render: (h, parms) => {
            return h("span", parms.row.keyPosition == 1 ? "是" : "否");
          },
        },
        {
          title: this.$t('keyPosition'), //"是否关键岗位"
          key: "cruxPosition",
          align: "center",
          minWidth: 120,
          render: (h, parms) => {
            return h("span", parms.row.cruxPosition == 1 ? "是" : "否");
          },
        },
        {
          title: this.$t('TalentPoolTag'),//"人才池标签"
          slot: "talentPool ",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('Action'),//"操作"
          slot: "action",
          align: "center",
          width: 90,
        },
      ];
    },
    importColumns() {
      return [
        {
          title: this.$t('Employee_Code'),
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('Name'),  
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('Position'), 
          key: "positionName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('StrategicPosition'), 
          key: "keyPosition",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t('keyPosition'), 
          key: "cruxPosition",
          align: "center",
          minWidth: 120,
        },
      ];
    },
  },
  created() {
    this.getData(true);
    this.getListData();
  },
  watch: {},
  methods: {
    getListData() {
      this.axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.functionList = res.functionList;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.TalentPoolList = res.TalentPool || [];
          this.businessUnitList = res.businessUnitList || [];
          this.departmentList = res.departmentList || [];
          this.YesOrNoList = res.YesOrNo || [];
          this.functionList = res.functionList || [];
          this.importRefColumns = [];
          this.importColumns.map((item) => {
            this.importRefColumns.push({
              title: item.title,
              key: item.key,
            });
          });
          this.TalentPoolList.map((item, index) => {
            item.key = item.code;
            item.label = item.ch_value;
            item.importKey = "key" + (index + 1);
            this.importRefColumns.push({
              title: item.key,
              key: item.importKey,
            });
          });
        }
      });
    },
    handleReset() {
      this.searchItem = {};
    },
    onHandleSearch(item) {
      this.searchItem = JSON.parse(item);
      this.getData(true);
    },
    renderTransfer(item) {
      return item.label;
    },
    handleTransferChange(newTargetKeys, direction, moveKeys) {
      this.targetKeys = newTargetKeys;
    },
    onEditItem(row, index) {
      this.editIndex = index;
      this.editItem = JSON.parse(JSON.stringify(row));
      if (this.editItem.talentPool) {
        this.targetKeys = this.editItem.talentPool.split(",");
      } else {
        this.targetKeys = [];
      }
      this.isShowModal = true;
    },
    onModalConfirm() {
      this.isShowModal = false;
      let talentPool = this.targetKeys.join(",");
      this.axios
        .post("/empKeyPosition/saveEmpKeyPosition", {
          id: this.editItem.id, // row.id  （没有也无所谓，后台判断用）
          serialnumber: this.editItem.serialnumber,
          empCode: this.editItem.empCode,
          keyPosition: this.editItem.keyPosition, //是否关键岗位
          talentPool: talentPool, // 人才池标签 （字符串）
          cruxPosition:this.editItem.cruxPosition
        })
        .then((res) => {
          if (res) {
            if (res) {
              this.$Message.success(res);
              this.getData();
            }
          }
        });
    },
    getData(flag) {
      if (flag) {
        this.pageInfo.pageNo = 1;
        this.pageInfo.total = 0;
      }
      this.spinShow = true;
      this.axios
        .post("/empKeyPosition/searchEmpKeyPosition", {
          ...this.searchItem,
          serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
            .serialnumber,
          ...this.pageInfo,
        })
        .then((res) => {
          this.spinShow = false;
          this.$refs.FormComponent.prevent = false;
          this.tableData = res.data || [];
          this.pageInfo.total = parseInt(res.pageInfo.total);
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    exportData() {
      this.spinShow = true;
      this.axios({
        url: "/empKeyPosition/downloadEmpKeyPositionTemplate",
        method: "post",
        data: {},
        responseType: "blob",
      }).then((res) => {
        var A =
          this.$store.getters.pageData.axiosHeader["content-disposition"].split(
            "filename="
          )[1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
        this.spinShow = false;
      });
    },
    exportDataEmp(){
      this.spinShow = true;
      this.axios({
        url: "/empKeyPosition/downloadEmpKeyPositionTemplate",
        method: "post",
        data: {...this.searchItem,downloadEmp:"1"},
        responseType: "blob",
      }).then((res) => {
        var A =
          this.$store.getters.pageData.axiosHeader["content-disposition"].split(
            "filename="
          )[1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
        this.spinShow = false;
      });
    },
    handelFile() {
      this.$refs.uploadExcel.click();
    },
    importExcel(e) {
      var file_name = document.getElementById("excel-file").value;
      file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase();
      var uploadFormat = [".xlsx", ".xls"];
      if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
        this.$Message.warning({
          content:
            "文件类型不正确, 请选择" + uploadFormat.join(" or ") + "类型",
          duration: 5,
        });
        return;
      }
      this.spinShow = true;
      this.$importExcel("excel-file", e, "inportTableRef", (data) => {
        this.importData = data;
        this.spinShow = false;
        this.isShowImportModal = true;
      });
    },
    importEmpKeyPosition() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          this.spinShow = true;
          this.axios
            .post("/empKeyPosition/importEmpKeyPosition", this.importData)
            .then((res) => {
              this.spinShow = false;
              if (res) {
                this.isShowImportModal = false;
                this.$Message.success("导入成功");
                this.getData(true);
              }
            });
        },
      });
    },
  },
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PositionInventory.vue